export interface IExploreMetadata {
  region: string;
  partner_counts: number;
  monthly_searches: number[] | null;
  competition_index: number | null;
  consultant_counts: number;
  avg_monthly_searches: number | null;
  vendor_trust_index: number | null;
  customer_insights_index: number | null;
  A_corporate_financial_maturity: number | null;
  B_market_traction: number | null;
  C_ecosystem_growth: number | null;
  local_support_index: number | null;
  interest_radar_index: number | null;
}


export interface IExploreProduct {
  id: string;
  productId: string;
  section: number;
  status: string;
  productName: string;
  isPinned: boolean;
  productDescription: string;
  marketAdoptionScore: number | null;
  productWebsite?: string | null;
  rating: number;
  logo: string | null;
  previousSection: number | null;
  exploreMetadata: IExploreMetadata | null;
  totalReviews: number;
  prosCons: {
    cons: string[];
    pros: string[];
  } | null;
}


export enum ISpecificationExploreSection {
  MATCHED_PRODUCT = 1,
  USER_AND_COMMENT_COUNT = 2,
  LOCAL_PARTNER_SUPPORT = 3,
  COMPETITIVE_INDEX = 4,
  PRODUCER_SCORE = 5
}

export enum FinishedPart {
  LOADING = "LOADING",
  ALL = "ALL",
  DB = "DB",
  GARTHNER = "GARTHNER",
  WEB = "WEB",
}

export enum ISpecificationExploreSectionStatus {
  DRAFT = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2
}

export interface IExploreSection {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  specificationId: string;
  status: ISpecificationExploreSectionStatus;
  section: number;
}
